import { render, staticRenderFns } from "./SupportTicketDialogStartedOn.vue?vue&type=template&id=ed6ddaa6"
import script from "./SupportTicketDialogStartedOn.vue?vue&type=script&lang=js"
export * from "./SupportTicketDialogStartedOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports